module.exports = __webpack_public_path__ + "static/media/stack-fill.398865c0.svg";